<template>
  <v-navigation-drawer v-model="drawer" app>
    <v-img
        height="140"
        class="pa-4"
        src="https://preview.pixlr.com/images/800wm/1439/2/1439104804.jpg"
    >
      <div class="text-center">
        <v-avatar class="mb-4" color="green darken-1" size="120">
          KES. {{ balance }}
<!--          <v-img-->
<!--              aspect-ratio="30"-->
<!--              src="https://yt3.ggpht.com/esazPAO03T0f0vKdByJvkDy6MSwjyG5f-c_2S2CJapszQ3KPQyZarpoqvgv0Us0atUbILytj=s88-c-k-c0x00ffffff-no-rj"-->
<!--          />-->
        </v-avatar>
        <h2 class="white--text">Politik<span class="pink--text">.sms</span></h2>
      </div>
    </v-img>
    <v-divider></v-divider>
    <v-list>
      <v-list-item v-for="[icon, text,to] in links"  :key="icon" link @click="$router.push({name:to})" exact>
        <v-list-item-icon>
          <v-icon>{{ icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {getRequest} from "@/api/apirepository";

export default {
  name: "Sidebar",
  props: ["drawer"],
  data() {
    return {
      balance:0,
      links: [
        ["mdi-microsoft-windows", "Dashboard",'UserDashboard'],
        ["mdi-currency-usd", "Cost Checker",'UserCostChecker'],
        ["mdi-chat", "SMS Center",'UserSmsCenter'],
        ["mdi-phone", "Call Poll Center",'UserCallCenter'],
        ["mdi-asterisk", "USSD Poll Center",'UserUssdCenter'],
        ["mdi-account", "All Candidates",'UserCandidates'],
        ["mdi-book", "USSD Poll Results",'UserResults'],
        ["mdi-currency-gbp", "Top Ups",'UserTopUps'],
        ["mdi-account-multiple", "Clients",'UserClientCenter'],
        ["mdi-cog", "System Setting","UserSettings"],
      ],
    };
  },
  methods:{
    getUserBalance() {
      getRequest('userBalance', {
        params: {
          id: this.$store.state.user.id
        }
      }).then(({data}) => {
        this.balance = data;
      }).catch(e => {
        console.log(e)
      })
    },
  }
};
</script>

<style scoped></style>
